<template>
  <div class="table__rows-container">
    <div
      v-for="item in data"
      :key="item.id"
      class="table__row"
      :class="rowClass"
    >
      <!-- 1 -->
      <div>
        <router-link class="link" :to="`/txs/${item.tx_hash}`">
          {{ ellipsis(item.tx_hash, 8) }}
        </router-link>
      </div>

      <!-- 2 -->
      <div>
        <span>{{ item.timeDiff }}</span>
      </div>

      <!-- 3 -->
      <div>
        <router-link
          class="link"
          :to="`/accounts/${item.from_address}`"
          v-if="item.from_address && item.from_address != accountAddress && checkAddress(item.from_address)"
          >{{ ellipsis(item.from_address, 8) }}</router-link
        >
        <span
          class="link"
          v-else-if="item.from_address && item.from_address != accountAddress && !checkAddress(item.from_address)"
          @click="goto(item.from_address)"
        >{{ ellipsis(item.from_address, 8) }}</span>
        <span v-else-if="item.from_address">
          {{ ellipsis(item.from_address, 8) }}
        </span>
        <span v-else>-</span>
      </div>

      <!-- 4 -->
      <div>
        <router-link
          class="link"
          :to="`/accounts/${item.to_address}`"
          v-if="item.to_address && item.to_address != accountAddress && checkAddress(item.to_address)"
        >{{ ellipsis(item.to_address, 8) }}
        </router-link>
        <span
          class="link"
          v-else-if="item.to_address && item.to_address != accountAddress && !checkAddress(item.to_address)"
          @click="goto(item.to_address)"
        >{{ ellipsis(item.to_address, 8) }}</span>
        <span v-else-if="item.to_address">
          {{ ellipsis(item.to_address, 8) }}
        </span>
        <span v-else>-</span>
      </div>

      <!-- 5 -->
      <div>
        <span v-if="item.amount">{{ item.amount }}</span>
        <span v-else>-</span>
      </div>

      <!-- 6 -->
      <div>
        <span>{{ item.type }}</span>
      </div>

      <!-- 7 -->
      <div>
        <span>{{ item.validation_code }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { ellipsis } from "../../../js/format";
import { etherScanUrl } from "../../../js/wpci";

export default {
  props: ["data", "accountAddress", "rowClass"],
  methods: {
    ellipsis: ellipsis,
    checkAddress(address) {
      const pci = "PCI";
      return address.startsWith(pci);
    },
    goto(address) {
      window.open(etherScanUrl + "/address/" + address)
    },
  },
};
</script>

<style lang="scss">
@mixin transferRow($width) {
  .from-address-arrow {
    a,
    span {
      min-width: $width;
    }
  }
}

.table__row--txs {
  @include transferRow(65%);

  &Home {
    @include transferRow(95px);
  }
}

.link {
  font-weight: 700;
  color: #0393f4;
  cursor: pointer;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/contents/shared/TableSlotTx.vue